import ProjectQueueTaskListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListRequest";
import ProjectQueueTaskListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListResponse";
import { QueueModel } from "../models";
import { ParentTaskModel } from "@/components";

export const mapGetListRequest = (groupId: number) =>
  new ProjectQueueTaskListRequest({
    GroupId: groupId,
  });

export const mapGetListResponse = (response: ProjectQueueTaskListResponse) =>
  response.Items.map(
    (queue) =>
      new QueueModel({
        Id: queue.Id,
        Name: queue.Name,
        TasksCount: queue.TaskCount,
        ParentTask: new ParentTaskModel({ ...queue.ParentTask }),
      }),
  );
